/**
 * 内容类型默认数据配置
 */

import { REQUIRED_NUTRIENTS, getStandardUnit } from '../../../config/nutrition.config';

// 基础内容类型默认数据
export const basicDefaults = {
  text: { 
    title: '', 
    content: '', 
    titleColor: '', 
    contentColor: '', 
    backgroundColor: '#ffffff' 
  },
  image: { 
    images: [], 
    backgroundColor: '#ffffff', 
    description: '',
    titleConfig: {
      enabled: true,
      chinese: '产品图',
      english: 'Product Images.',
      bgColor: '#1e90ff',
      textColor: '#ffffff'
    },
    carousel: {
      enabled: false,
      autoplay: true,
      interval: 3000,
      showArrows: true,
      showDots: true,
      loop: true
    } 
  },
  background: {
    applyTo: 'page', // 'page' | 'none' (预留)
    color: '#F5E6D3',
    gradient: { enabled: false, from: '#ffffff', to: '#ffffff', angle: 180 },
    image: null,
    size: 'cover', // cover/contain/auto/100% 100%
    position: 'center',
    repeat: 'no-repeat',
    overlayColor: '#000000',
    overlayOpacity: 0 // 0-1
  },
  video: { 
    video: null 
  },
  audio: { 
    audio: null 
  },
  link: { 
    layout: 'list',
    cardStyle: { bgColor: '#f8f9fa', textColor: '#202124', borderColor: '#e8eaed', borderWidth: 1, radius: 8, shadow: false },
    links: [{ 
      icon: '', 
      name: '官方网站', 
      url: '', 
      order: 1 
    }] 
  },
  attachment: { 
    layout: 'list',
    cardStyle: { bgColor: '#f8f9fa', textColor: '#202124', borderColor: '#e8eaed', borderWidth: 1, radius: 8, shadow: false },
    attachments: [
      { name: '标定文本', file: null },
      { name: '检验报告', file: null }
    ] 
  },
  divider: {
    style: 'line-dot', // solid | dashed | dotted | double | line-dot | line-square | line-diamond | line-triangle | wave | gradient
    color: '#D4BFA0',
    thickness: 4,
    lengthPercent: 88,
    align: 'right', // left | center | right
    showTop: true,
    showBottom: false,
    // 装饰元素配置（兼容旧字段）
    decorationColor: '#D4BFA0', // 装饰颜色
    decorationSize: 8, // 装饰大小
    dotColor: '#D4BFA0', // 兼容旧字段
    dotSize: 8, // 兼容旧字段
    // 渐变配置
    gradientFrom: '#D4BFA0',
    gradientTo: '#E5D4B0',
    // 间距
    marginTop: 12,
    marginBottom: 12
  },
};

// 业务模板默认数据
export const templateDefaults = {
  'product-basic': { 
    productName: '', 
    ingredients: '', 
    netContent: '', 
    standardCode: '',
    manufacturer: '', 
    address: '', 
    origin: '', 
    productionDate: '',
    shelfLife: '', 
    storageConditions: '', 
    productionLicense: '', 
    serviceHotline: '',
    customFields: [],
    titleConfig: {
      enabled: false,
      chinese: '产品基础信息',
      english: 'Product Basic information.',
      bgColor: '#1e90ff',
      textColor: '#ffffff'
    }
  },
  nutrition: { 
    items: REQUIRED_NUTRIENTS.map(name => ({
      name,
      per100g: '0',
      unit: getStandardUnit(name),
      nrv: '%',
      locked: false
    })),
    titleConfig: {
      enabled: false,
      chinese: '营养成分表',
      english: 'Nutrition Information.',
      bgColor: '#1e90ff',
      textColor: '#ffffff'
    }
  },
  usage: { 
    title: '', 
    video: null, 
    backgroundColor: '#1e90ff',
    titleConfig: {
      enabled: false,
      chinese: '食用方法',
      english: 'Direction for Consumption.',
      bgColor: '#1e90ff',
      textColor: '#ffffff'
    }
  },
  'related-links': { 
    layout: 'vertical-card',
    cardStyle: { bgColor: '#ffffff', textColor: '#5C4A37', borderColor: '#e8eaed', borderWidth: 1, radius: 12, shadow: true },
    logoSize: 72,
    links: [{ 
      enabled: true, 
      icon: '', 
      name: '官方网站', 
      url: '', 
      order: 1 
    }] 
  },
  inspection: { 
    borderColor: '#cccccc',
    attachments: [
      { enabled: true, name: '标准文本', file: null },
      { enabled: true, name: '检验报告', file: null }
    ]
  },
};

/**
 * 获取指定类型的默认数据
 */
export function getDefaultDataForType(type) {
  // 先检查基础类型
  if (basicDefaults[type]) {
    return basicDefaults[type];
  }
  
  // 再检查模板类型
  if (templateDefaults[type]) {
    return templateDefaults[type];
  }
  
  // 默认返回空对象
  return {};
}
